import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoEvents, TranslocoService } from '@ngneat/transloco';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MatPaginationIntlService extends MatPaginatorIntl {
  private readonly translateService = inject(TranslocoService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    super();
    // Los labels se leen de forma sincrónica, así que hay que re-leerlos cuando termina
    // de cargar el archivo del idioma y cuando el usuario cambia de idioma.
    this.translateService.events$
      .pipe(
        filter(
          (evento: TranslocoEvents) =>
            evento.type === 'translationLoadSuccess' ||
            evento.type === 'langChanged',
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.translateLabels());
    this.translateLabels();
  }

  public getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ): string => {
    const of: string = this.translateService.translate('paginador.of');
    if (length === 0 || pageSize === 0) return `0 ${of} ${length}`;
    const total: number = Math.max(length, 0);
    const startIndex: number =
      page * pageSize > total
        ? (Math.ceil(total / pageSize) - 1) * pageSize
        : page * pageSize;
    const endIndex: number = Math.min(startIndex + pageSize, total);
    return `${startIndex + 1} - ${endIndex} ${of} ${total}`;
  };

  private translateLabels(): void {
    this.firstPageLabel = this.translateService.translate(
      'paginador.firstPageLabel',
    );
    this.itemsPerPageLabel = this.translateService.translate(
      'paginador.itemsPerPageLabel',
    );
    this.lastPageLabel = this.translateService.translate(
      'paginador.lastPageLabel',
    );
    this.nextPageLabel = this.translateService.translate(
      'paginador.nextPageLabel',
    );
    this.previousPageLabel = this.translateService.translate(
      'paginador.previousPageLabel',
    );
    this.changes.next();
  }
}
